export default {
  topbar: {
    title: "Låteditor"
  },
  saveButton: {
    title: "Lagre"
  },
  items: {
    title: "Tittel",
    artists: "Artister",
    platforms: "Platformer",
    metadata: {
      title: "Metadata",
      key: "Toneart",
      bpm: "BPM",
      length: "Lengde",
      loudness: "Lydstyrke",
      genre: "Sjanger",

      spotify: {
        find: "Autofyll"
      }
    },
    misc: {
      title: "Diverse",
      explicit: {
        title: "Eksplisitt",
        hint: "Låta er sterkt kontroversiell, har upassende motiver eller inneholder grove ord og uttrykk"
      }
    },
    releaseDate: {
      title: "Publiseringsdato",
      isReleased: "Sangen vil bli publisert",
      notReleased: "Sangen vil ikke bli publisert",
    },
    coverart: {
      title: "Albumkunst",
      delete: {
        tooltip: "Slett"
      },
      dragAndDrop: "Dra fil eller klikk for å laste opp"
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/no/component/module/artist/trackEditor.js